import { useState } from "react";
import "./modal.css";

export default function Modal({ title, children, onConfirm, onCancel, isDashboard, theme }) {
    const [isHoverYes, setIsHoverYes] = useState(false);
    const [isHoverNo, setIsHoverNo] = useState(false);
    return (
        <div className="overlay">
            <div className="modal" style={{backgroundColor:isDashboard ? theme?.accent_color : "white"}}>
                <h3 dir="rtl" style={{color:isDashboard ? theme?.primary_color : "rgba(30, 70, 130, 1)"}}>{title}</h3>
                <div>{children}</div>

                <div className="actions">
                    <button onMouseEnter={()=>{setIsHoverNo(true)}} onMouseLeave={()=>{setIsHoverNo(false)}} style={{backgroundColor:isHoverNo?"whitesmoke":"rgba(240,0,0,0.8)", color:isHoverNo?"rgba(240,0,0,0.8)":"whitesmoke", border:isHoverNo?"0.5px solid rgba(240,0,0,0.8)":"none"}} onClick={onCancel}>ביטול</button>
                    <button onMouseEnter={()=>{setIsHoverYes(true)}} onMouseLeave={()=>{setIsHoverYes(false)}} style={{backgroundColor:isHoverYes?"whitesmoke":"rgba(0,240,0,0.8)", color:isHoverYes?"rgba(0,240,0,0.8)":"whitesmoke", border:isHoverYes?"0.5px solid rgba(0,240,0,0.8)":"none"}} onClick={onConfirm}>אישור</button>
                </div>
            </div>
        </div>
    );
}
